import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { recommendTagActions } from '../../../store/modules/recommend/tag';
import RecommendTagDetailWrap from '../../../views/recommend/tag/detail/RecommendTagDetailWrap';

class RecommendTagDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendTagId) => {
    const { getRecommendTagDetail } = this.props;

    getRecommendTagDetail({
      recommendTagId,
    });
  };

  render() {
    const { recommendTagDetail } = this.props;

    return <RecommendTagDetailWrap recommendTagDetail={recommendTagDetail} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendTagDetail: state.recommendTag.recommendTagDetail,
  };
};

const mapDispatchToProps = {
  getRecommendTagDetail: recommendTagActions.getRecommendTagDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendTagDetailContainer));
